import { IconInfo } from "../../components/ui/Icons";

function UnderConstructionArt() {
  return (
    <svg className="ucArt" viewBox="0 0 760 380" role="img" aria-label="Ilustracja strony w budowie">
      <defs><linearGradient id="g1" x1="0" x2="1" y1="0" y2="1"><stop offset="0" stopColor="rgba(3,145,232,.25)" /><stop offset="1" stopColor="rgba(34,197,94,.18)" /></linearGradient></defs>
      <rect x="0" y="0" width="760" height="380" rx="22" fill="url(#g1)" />
      <g opacity="0.9"><circle cx="110" cy="92" r="36" fill="rgba(3,79,189,.16)" /><circle cx="660" cy="78" r="44" fill="rgba(34,197,94,.14)" /><circle cx="640" cy="300" r="54" fill="rgba(3,145,232,.12)" /></g>
      <g transform="translate(250 92)"><path d="M130 220h0c-12 0-22-10-22-22l44-174c2-8 10-14 18-14h0c8 0 16 6 18 14l44 174c0 12-10 22-22 22H130Z" fill="rgba(255,255,255,.88)" stroke="rgba(15,23,42,.14)" strokeWidth="2" /><path d="M168 32h64l-16 64h-64l16-64Z" fill="rgba(242,183,5,.85)" /><path d="M152 96h64l-10 44h-64l10-44Z" fill="rgba(3,79,189,.18)" /><path d="M144 140h64l-8 34h-64l8-34Z" fill="rgba(242,183,5,.75)" /><rect x="118" y="220" width="250" height="20" rx="10" fill="rgba(11,19,42,.12)" /></g>
      <g transform="translate(42 300)"><rect x="0" y="0" width="240" height="46" rx="14" fill="rgba(255,255,255,.86)" stroke="rgba(15,23,42,.10)" /><text x="18" y="30" className="ucArtLabel" fill="rgba(11,19,42,.82)">Prace trwają</text></g>
    </svg>
  );
}

export default function UnderConstructionPage() {
  return (
    <section className="pageSection pageWithHeaderOffset">
      <div className="container">
        <section className="card ucCard">
          <div className="ucTop">
            <div className="ucBadge"><span className="ucBadgeIcon" aria-hidden="true"><IconInfo /></span><span>Strona w budowie</span></div>
            <h1 className="ucTitle">Pracujemy nad tą częścią strony</h1>
            <p className="ucText">Wkrótce pojawią się tu treści związane z historią i trasą. Na ten moment przygotowujemy materiały, zdjęcia oraz opisy przystanków.</p>
            <div className="ucPills"><span className="pill ok">Status: w przygotowaniu</span><span className="pill">Aktualizacje: sukcesywnie</span></div>
          </div>
          <div className="ucMedia"><UnderConstructionArt /><div className="ucCaption">Dziękujemy za cierpliwość</div></div>
        </section>
      </div>
    </section>
  );
}